// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2Amm1","messages":"Chat_messages__3gY-Z","dateDivider":"Chat_dateDivider__3imfQ"};